export const VEHICLE_DOCUMENT_NAMES = [
  'payment_confirmation',
  'invoice_sales',
  'invoice_purchase',
  'release_report',
  'rdw_vehicle_report',
  'report_accept_bedrijfsvoorraad',
  'machtigings_form',
  'credit_invoice',
  'import_report',
  'regplate_foreign',
  'cvo_coc',
  'invoice_export_proforma',
  'cmr',
  'verklaring_nieuw_en_ongebruikt',
  'order_confirmation',
  'tdn',
  'other',
];

export const COMPANY_DOCUMENT_NAMES = [
  'kvk',
  'btw_summary',
  'location',
  'credit_check',
  'iban_check',
  'vies_check',
  'id',
  'kvk_btw',
  'bank_card',
  'overig',
];

export const USER_DOCUMENT_NAMES = ['ID_front', 'ID_back', 'copy_bank_card'];
